<template lang="pug">
  .hisotory(v-if="history.length > 0")
    .card-box
      h4.header-title.text-dark.m-b-20 最近見たレポート
      .row
        .col-lg-3.col-md-4.col-sm-6(v-for="record in history")
          router-link(v-bind:to="`/reports/${record.id}`")
            img.img-resposive.img-thumbnail(v-bind:src="record.thumbnail")
            p {{record.title}}
</template>

<script>
import Lib from '@/lib'

export default {
  props: {
    history: {
      type: Array,
      default: () => {
        const history = new Lib.History(window.localStorage.getItem('history'))
        return history.records
      },
    },
  },
}
</script>